import { amountLabel } from '../../../services/Units';
import React, { useState, useEffect } from "react";
import { PlusIcon, PencilIcon, XIcon } from '@heroicons/react/solid'
import Modal from "../Modal/Modal";
import PlansForm from "../../forms/PlansForm/PlansForm";

const PlanTableCellDay = ({ options, addMeal, removeMeal, day, existingRecipes, mealIndex, colSpan, showMergeToggle, onMergeToggle, selectedClient, usedRecipes }) => {
    const [isOpen, setIsOpen] = useState(false)
    const [groceriesData, setGroceriesData] = useState(null)
    const [planDescription, setPlanDescription] = useState('');
    const [planRecipeItems, setPlanRecipeItems] = useState([]);
    const [planCalories, setPlanCalories] = useState('');


    useEffect(() => {
        if (existingRecipes) {
            setPlanRecipeItems(existingRecipes)
            setGroceriesData(options)
        } else {
            // prazan jelovnik / prazna celija - ocisti prikaz da se ne zadrzi
            // sadrzaj iz prethodnog jelovnika
            setPlanRecipeItems([])
        }
    }, [existingRecipes])

    const submitMeal = (recipeItems) => {
        setPlanRecipeItems(recipeItems)
        addMeal(recipeItems, day, mealIndex)
    }

    const mapRecipeItems = (planRecipeItems) => {
        return planRecipeItems && planRecipeItems.recipes && planRecipeItems.recipes.map(({ value, servingSize }, i) => (
            <div className="border bg-white border-bluePrimary border-opacity-20 rounded mt-3 firt:mt-0 py-1.5 px-2 text-center text-xs font-semibold" key={i}>
                <span>{value}</span>
            </div>
        ))
    };

    const mapGroceryItems = (planRecipeItems) => {
        return planRecipeItems && planRecipeItems.groceries && planRecipeItems.groceries.map(({ value, servingSize, unit }, i) => (
            <div className="flex flex-wrap justify-center border bg-white border-bluePrimary border-opacity-20 rounded mt-3 firt:mt-0 py-1.5 px-2 text-center  text-xs" key={i}>
                <span className="font-semibold">{value}</span>
                <span className="ml-2 mt-0.5 text-[10px]">{amountLabel(servingSize, unit)}</span>
            </div>
        ))
    };

    const displayAdditionalButtons = planDescription || (planRecipeItems.recipes && planRecipeItems.recipes.length) || (planRecipeItems.groceries && planRecipeItems.groceries.length);
    return (
        <td colSpan={colSpan || 1} className={`relative py-5 px-2 xl:px-4 font-medium text-sm align-top ${colSpan > 1 ? "" : "max-w-[120px] min-w-[120px]"}`}>
            {showMergeToggle &&
                <label className="flex items-center justify-center text-[10px] text-gray-400 cursor-pointer select-none mb-1">
                    <input type="checkbox" className="mr-1 accent-blueSecondary cursor-pointer" checked={false} readOnly onClick={() => onMergeToggle(mealIndex, day)} />
                    spoji
                </label>}
            <div className={` ${displayAdditionalButtons ? 'absolute right-1 top-1.5  ' : 'text-center'}`}>

                <button className={`text-white rounded-full ${displayAdditionalButtons ? ' w-5 h-5 p-1 bg-blueSecondary' : 'w-8 h-8 p-1.5 bg-bluePrimary transform hover:rotate-90 transition'}`} onClick={() => setIsOpen(true)} >
                    {displayAdditionalButtons ?
                        <PencilIcon />
                        :
                        <PlusIcon />
                    }
                </button>
                {displayAdditionalButtons ?
                    <button className="w-5 h-5 p-1 bg-red-500 text-white rounded-full ml-1" onClick={() => {
                        setPlanRecipeItems('');
                        setPlanDescription('');
                        setPlanCalories('');
                        removeMeal(planRecipeItems, day, mealIndex)
                    }
                    }
                    >
                        <XIcon />
                    </button>
                    : ''
                }
            </div>

            {
                isOpen &&
                <Modal
                    setIsOpen={setIsOpen}
                    modalContent={<PlansForm options={options}
                        planDescription={planDescription}
                        setPlanCalories={setPlanCalories}
                        setPlanDescription={setPlanDescription}
                        planRecipeItems={planRecipeItems}
                        setPlanRecipeItems={submitMeal}
                        setIsOpen={setIsOpen}
                        groceriesData={groceriesData}
                        selectedClient={selectedClient}
                        usedRecipes={usedRecipes}
                    />} />
            }
            {/* <h4 className="font-semibold text-lg">{planRecipeItems}</h4> */}
            {mapRecipeItems(planRecipeItems)}
            {mapGroceryItems(planRecipeItems)}
            {planRecipeItems && planRecipeItems.note &&
                <div className="mt-2 rounded bg-amber-50 border border-amber-200 px-2 py-1 text-[10px] text-amber-800 text-center">
                    📌 {planRecipeItems.note}
                </div>}
        </td >
    );
};

export default PlanTableCellDay;



